export default {
    id: 'en',
    noDesktop: {
        line1: 'SSStrasznie nam przykro',
        line2: 'aktualnie Atas nie jest dostosowany do urzadzeń nie mobilnych. Zmniejsz ekran lub uruchom naszą aplikacje pobierając ją z Sklepu Play lub App Store',
    }
}